var _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCircleCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 14.5,
    r: 14,
    stroke: "black",
    strokeOpacity: 0.25
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 8.85355,
    y1: 7.64645,
    x2: 21.8536,
    y2: 20.6464,
    stroke: "black",
    strokeOpacity: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.5,
    x2: 18.3848,
    y2: -0.5,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 22.5 8)",
    stroke: "black",
    strokeOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleCross);
export default __webpack_public_path__ + "static/media/icon-circle-cross.6f613fff2023c9c1025d44ce6f67ce2b.svg";
export { ForwardRef as ReactComponent };